import React, { useEffect } from 'react';

import { Button, ButtonPriority } from 'wix-ui-tpa/cssVars';
import { classes, st } from './LoadServicesButton.st.css';
import { useStyles } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import stylesParams from '../../../stylesParams';
import { SpinnerWrapper } from '@wix/bookings-viewer-ui';
import { useWidgetViewModel } from '../../hooks/useWidgetViewModel';

export type LoadServicesButtonProps = {
  text: string;
  className?: string;
  onClick: () => void;
  dataHook: string;
};

export const DataHooks = {
  BUTTON: 'load-services-button-button',
  SPINNER: 'load-services-button-spinner',
};

export const LoadServicesButton = ({
  text,
  className,
  onClick,
  dataHook,
}: LoadServicesButtonProps) => {
  const [loading, setLoading] = React.useState(false);
  const styles = useStyles();

  const { isMobile } = useEnvironment();
  const { servicesPagingMetadata } = useWidgetViewModel();
  const spinnerDiameter = styles.get(stylesParams.loadServicesButtonFont).size;

  useEffect(() => {
    setLoading(false);
  }, [servicesPagingMetadata]);

  return (
    <div data-hook={dataHook} className={st(classes.root, className)}>
      <Button
        upgrade
        data-hook={DataHooks.BUTTON}
        className={st(classes.button)}
        onClick={() => {
          setLoading(true);
          onClick();
        }}
        priority={ButtonPriority.secondary}
        fullWidth={isMobile}
      >
        {loading ? (
          <div className={classes.spinnerWrapper}>
            <SpinnerWrapper
              className={classes.spinner}
              diameter={spinnerDiameter}
              data-hook={DataHooks.SPINNER}
            />
          </div>
        ) : (
          text
        )}
      </Button>
    </div>
  );
};
